import { render, staticRenderFns } from "./TprepBatchAdd.vue?vue&type=template&id=7315ef3b"
import script from "./TprepBatchAdd.vue?vue&type=script&lang=js"
export * from "./TprepBatchAdd.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports